"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cssClassesHelper = require("../../../../helpers/cssClassesHelper");
var _withdrawHelper = require("../../../../helpers/withdrawHelper");
var _Spinner = _interopRequireDefault(require("../../../common/Spinner/Spinner"));
var _VerificationRequiredContainer = _interopRequireDefault(require("../../../VerificationRequired/VerificationRequiredContainer"));
var _DepositTemplateFormContainer = _interopRequireDefault(require("../../../DepositSidePaneComponents/DepositTemplateFormContainer"));
var _DepositWorkflowsContainer = _interopRequireDefault(require("../../../DepositSidePaneComponents/DepositWorkflows/DepositWorkflowsContainer"));
var _classnames = _interopRequireDefault(require("classnames"));
var _APSelect = _interopRequireDefault(require("../../../common/APSelect"));
var _config = _interopRequireDefault(require("../../../../config"));
var _RequestFiatTransfer = _interopRequireDefault(require("../../../RequestFiatTransfer/RequestFiatTransfer"));
require("./FiatDepositFormComponent.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var baseClasses = (0, _cssClassesHelper.getBEMClasses)('fiat-deposit-form');
var slidePaneClasses = (0, _cssClassesHelper.getBEMClasses)('fiat-slide-pane');
var FiatDepositFormComponent = /*#__PURE__*/function (_React$Component) {
  function FiatDepositFormComponent() {
    var _this;
    _classCallCheck(this, FiatDepositFormComponent);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, FiatDepositFormComponent, [].concat(args));
    _defineProperty(_this, "state", {
      isTransfer: false
    });
    _defineProperty(_this, "toggleTransfer", function () {
      if (_config["default"].global.allowTransfer) {
        _this.setState({
          isTransfer: !_this.state.isTransfer
        });
      }
    });
    return _this;
  }
  _inherits(FiatDepositFormComponent, _React$Component);
  return _createClass(FiatDepositFormComponent, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var _this$props = this.props,
        ProductId = _this$props.product.ProductId,
        selectDepositProduct = _this$props.selectDepositProduct,
        selectPosition = _this$props.selectPosition;
      selectPosition(ProductId);
      selectDepositProduct(ProductId);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.initialize(_objectSpread({}, this.props.product));
    }
  }, {
    key: "render",
    value: function render() {
      var t = this.props.t;
      var _this$props2 = this.props,
        disableDeposit = _this$props2.disableDeposit,
        deposit = _this$props2.depositInfo,
        _this$props2$depositI = _this$props2.depositInfo,
        templateTypes = _this$props2$depositI.templateTypes,
        isLoading = _this$props2$depositI.isLoading,
        error = _this$props2$depositI.error,
        depositInfo = _this$props2$depositI.depositInfo,
        product = _this$props2.product,
        handleSubmit = _this$props2.handleSubmit,
        submitting = _this$props2.submitting,
        selectDepositTemplate = _this$props2.selectDepositTemplate,
        verificationOnClick = _this$props2.verificationOnClick,
        allowTransfer = _this$props2.allowTransfer;
      var showTemplateTypeSelect = (0, _withdrawHelper.showTemplateSelect)(deposit);
      var templateTypeOptions = [{
        value: '',
        label: 'Select an option'
      }].concat(_toConsumableArray(templateTypes.map(function (template) {
        return {
          value: template.AccountProviderId,
          label: template[_config["default"].Deposit.AccountProviderDisplayKey]
        };
      })));
      var useTemplateDepositWorkflow = depositInfo && !depositInfo.length;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("section", {
        className: baseClasses('send-to')
      }, /*#__PURE__*/_react["default"].createElement("header", {
        className: baseClasses('source')
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('source-item-with-border')
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('source-item', {
          selected: !this.state.isTransfer
        }),
        onClick: this.toggleTransfer
      }, t("External Account"))), allowTransfer && /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('source-item', {
          selected: this.state.isTransfer
        }),
        onClick: this.toggleTransfer
      }, t("Request Transfer")))), isLoading ? /*#__PURE__*/_react["default"].createElement(_Spinner["default"], {
        customClass: baseClasses
      }) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, this.state.isTransfer ? /*#__PURE__*/_react["default"].createElement(_RequestFiatTransfer["default"], null) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_DepositWorkflowsContainer["default"], {
        onSubmit: handleSubmit,
        submitting: submitting
      }), error && /*#__PURE__*/_react["default"].createElement("p", {
        className: baseClasses('error')
      }, t(error)), useTemplateDepositWorkflow && /*#__PURE__*/_react["default"].createElement("form", {
        className: (0, _classnames["default"])(slidePaneClasses('body'), baseClasses('body')),
        onSubmit: handleSubmit
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('form-body')
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('frame')
      }, disableDeposit ? /*#__PURE__*/_react["default"].createElement(_VerificationRequiredContainer["default"], {
        disabled: disableDeposit,
        onClick: verificationOnClick
      }) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, showTemplateTypeSelect && /*#__PURE__*/_react["default"].createElement(_APSelect["default"], {
        name: "TemplateType",
        customClass: baseClasses(),
        label: t("Select an option to continue the deposit process"),
        onSelect: function onSelect(value) {
          return selectDepositTemplate(product.ProductId, value);
        },
        options: templateTypeOptions
      }), /*#__PURE__*/_react["default"].createElement(_DepositTemplateFormContainer["default"], {
        submitting: submitting,
        baseClasses: baseClasses
      }))))))));
    }
  }]);
}(_react["default"].Component);
FiatDepositFormComponent.defaultProps = {
  deposit: {
    templateInfo: {},
    template: {},
    isLoading: false,
    error: '',
    depositInfo: {},
    depositStatus: {}
  }
};
FiatDepositFormComponent.propTypes = {
  disableDeposit: _propTypes["default"].bool,
  handleSubmit: _propTypes["default"].func,
  submitting: _propTypes["default"].bool,
  showSnack: _propTypes["default"].func,
  deposit: _propTypes["default"].shape({
    templateInfo: _propTypes["default"].object.isRequired,
    template: _propTypes["default"].object.isRequired,
    isLoading: _propTypes["default"].bool.isRequired,
    error: _propTypes["default"].string.isRequired,
    product: _propTypes["default"].number,
    depositInfo: _propTypes["default"].oneOfType([_propTypes["default"].array, _propTypes["default"].object]).isRequired,
    depositStatus: _propTypes["default"].shape({
      success: _propTypes["default"].bool,
      RequestCode: _propTypes["default"].string
    }).isRequired
  }),
  verificationOnClick: _propTypes["default"].func
};
var _default = exports["default"] = (0, _reactI18next.withTranslation)("core")(FiatDepositFormComponent);